<template>
    <div class="flex flex-row space-x-8 pb-10 pl-8">
        <div class="flex flex-row">
            <div>
                <div class="relative flex items-center gap-x-5">
                    <!-- CARTÕES ANTERIORES -->
                    <div class="relative">
                        <div class="flex absolute right-0 -top-20 gap-x-5">
                            <div
                                v-for="(card, index) in cardsBeforeActive"
                                :key="card.uuid"
                                :class="selectedCard !== index ? '' : ''"
                            >
                                <div>
                                    <card-fisico
                                        v-if="!card.is_virtual"
                                        :card="card"
                                        :size="'w-80 h-40'"
                                        :isActiveCard="false"
                                    />
                                    <card-virtual
                                        v-if="card.is_virtual"
                                        :card="card"
                                        :size="'w-80 h-40'"
                                        :isActiveCard="false"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- CARTÃO SELECIONADO -->
                        <div class="relative">
                            <div class="flex items-center justify-center bg-black bg-opacity-80 h-10 w-10 rounded-full absolute -left-12 top-2/4 transform -translate-y-2/4 mr-3 self-center"
                            :class="selectedCard === 0 ? 'bg-gray-400 bg-opacity-25' : 'cursor-pointer'"
                            @click="pastCard"
                            >
                                <em class=" text-white text-2xl fas fa-angle-left" />
                            </div>
                            <transition-group :name="transitionName">
                                <div :key="selectedCard">
                                    <card-fisico
                                        v-if="!cards[selectedCard].is_virtual"
                                        :card="cards[selectedCard]"
                                        :isActiveCard="true"
                                    />
                                    <card-virtual
                                        v-if="cards[selectedCard].is_virtual"
                                        :card="cards[selectedCard]"
                                        :isActiveCard="true"
                                    />
                                </div>
                            </transition-group>
                             <div class="flex items-center justify-center bg-black bg-opacity-80 h-10 w-10 rounded-full  absolute -right-12 top-2/4 transform -translate-y-2/4 ml-3 self-center z-50"
                             :class="selectedCard + 1 === cards.length ? 'bg-gray-400 bg-opacity-25' : 'cursor-pointer'"
                             @click="nextCard"
                             >
                                <em class="text-white text-2xl fas fa-angle-right" />
                            </div>
                        </div>
                    <!-- PROXIMOS CARTÕES -->
                    <div
                        v-for="(card, index) in cardsAfterActive"
                        :key="card.uuid"
                        :class="selectedCard !== index ? '' : ''"
                    >
                        <div>
                            <card-fisico
                                v-if="!card.is_virtual"
                                :card="card"
                                :size="'w-80 h-40'"
                                :isActiveCard="false"
                            />
                            <card-virtual
                                v-if="card.is_virtual"
                                :card="card"
                                :size="'w-80 h-40'"
                                :isActiveCard="false"
                            />
                        </div>
                    </div>
                </div>
                <div class="flex items-center justify-center mt-5 space-x-3 w-96">
                    <slide-separator
                        :count="cards.length"
                        :activated="selectedCard"
                        @go-to="goToCard"
                    />
                </div>
            </div>

        </div>
    </div>
</template>
<script>
import CardFisico from './CardFisico.vue';
import CardVirtual from './CardVirtual.vue';
import SlideSeparator from "./SlideSeparator.vue";
export default {
    components: { SlideSeparator, CardFisico, CardVirtual,  },
    props: {
        cards: {
            type: Array,
            default: []
        },
        selectedCard: {
            type: Number,
            required: true
        },
    },
    data() {
        return {
            transitionName: 'next-slide'
        }
    },
    computed: {
        cardsBeforeActive() {
            return this.cards.filter((card, index) => {
                if(index < this.selectedCard) {
                    return true;
                }
            })
        },
         cardsAfterActive() {
            return this.cards.filter((card, index) => {
                if(index > this.selectedCard) {
                    return true;
                }
            })
        },
    },
    methods: {
        goToCard(indexCard) {
            const selectedCard = indexCard;
            const activeCard = this.cards[selectedCard] ?? {};
            this.vistiCard(activeCard, selectedCard)
        },
        nextCard() {
            const totalCard = this.cards.length
            if(this.selectedCard  === totalCard - 1) return
            const selectedCard = this.selectedCard + 1
            const activeCard = this.cards[selectedCard]
            this.transitionName = 'next-slide'
            this.vistiCard(activeCard, selectedCard)
        },
        pastCard() {
            if(this.selectedCard === 0) return
            const selectedCard = this.selectedCard - 1
            const activeCard = this.cards[selectedCard]
            this.transitionName = 'previous-slide'
            this.vistiCard(activeCard, selectedCard)
        },
        vistiCard(activeCard, selectedCard) {
            this.$inertia.get(this.route('card.index'), {uuid: activeCard.uuid ?? activeCard.reference_card_uuid}, {
                preserveState: true,
                onSuccess:() => {
                    this.$forceUpdate();
                    this.$emit('active-card', {
                        selectedCard,
                        activeCard
                    })
                }
            })
        },
    },
};
</script>
<style>
    .next-slide-enter-active,
    .previous-slide-enter-active{
        transition: transform .5s ease;
    }
    .next-slide-leave-active,
    .previous-slide-leave-active{
        transition: .2s ease all;
        position: absolute;
    }
    .next-slide-enter{
        transform: translateX(50%) scale(0.60);
    }
    .next-slide-leave-to,
    .previous-slide-leave-to {
        transform: translateX(0);
    }
    .previous-slide-enter{
        transform: translateX(-50%) scale(0.60);
    }
</style>
